import { defineFcm } from '../shared/factory';

export const FCM_STARTER_SAP_PHONE_COLLECTION = defineFcm('starter_sap_phone_collection')
	.asEnum(['off', 'optional', 'mandatory'])
	.withDefault('off')
	.toConfig();
